import * as React from 'react';

import styled, { css } from 'styled-components';

import { motion, useMotionValue, useTransform } from 'framer-motion';

export interface UnselectedIconProps {
  className?: string;
  iconSize?: number;
  active?: boolean;
  noAnimation?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  isDark?: boolean;
  isWhite?: boolean;
  disabled?: boolean;
  noLine?: boolean;
  error?: boolean;
}

export const UnselectedIcon: React.FC<UnselectedIconProps> = (props) => {
  const pathLength = useMotionValue(0);
  const opacity = useTransform(pathLength, [0.05, 0.15], [0, 1]);

  const path = {
    hidden: {
      pathLength: 0,
    },
    visible: {
      pathLength: 1,
      transition: {
        duration: 4,
        type: 'spring',
        stiffness: 50,
      },
    },
    exit: {
      pathLength: 0,
    },
  };
  return (
    <svg
      className={props.className}
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {!props.disabled && !props.noLine && (
        <motion.path
          className={`path ${props.isDark ? 'dark' : ''} ${
            props.isWhite ? 'white' : ''
          } ${props.error ? 'error' : ''}`}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeLinejoin="round"
          d="M 9.5 14.5 L 14.5 9.5"
          initial={'hidden'}
          animate={'visible'}
          exit={'hidden'}
          variants={path}
          style={{ pathLength: pathLength, opacity: opacity }}
        />
      )}
      <motion.path
        className={`circle ${props.isDark ? 'dark' : ''} ${
          props.isWhite ? 'white' : ''
        } ${props.error ? 'error' : ''}`}
        d="M1,12a11,11 0 1,0 22,0a11,11 0 1,0 -22,0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        initial={'hidden'}
        animate={'visible'}
        exit={'hidden'}
        variants={path}
        style={{ pathLength: pathLength, opacity: opacity }}
      />
    </svg>
  );
};

export default styled(UnselectedIcon)`
  width: ${(props) => (props.iconSize ? props.iconSize : '32')}px;
  height: ${(props) => (props.iconSize ? props.iconSize : '32')}px;
  opacity: ${(props) => (props.active ? '1' : '.3')};

  ${(props) =>
    props.onClick
      ? css`
          cursor: pointer;
        `
      : null}

  .path,
  .circle {
    fill: none;
    stroke: ${({ theme }) => theme.colors.primary};
    opacity: ${(props) => (props.active ? `1` : `0.5`)};
    transition: stroke
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &.dark {
      stroke: ${({ theme }) => theme.colors.background};
    }
    &.white {
      stroke: ${({ theme }) => theme.colors.white};
    }
    &.error {
      stroke: ${({ theme }) => theme.colors.error};
      opacity: 1;
    }
  }

  ${(props) =>
    props.noAnimation
      ? css`
          .path,
          .circle {
            opacity: 1;
            animation: none;
            stroke-dasharray: 0;
            stroke-dashoffset: 0;
          }
        `
      : null}
`;
